import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";
const CoreStrengthsSection = lazy(() => import("./CoreStrengthsSection"));
const CompetitiveAdvantageSection = lazy(() => import("./CompetitiveAdvantageSection"));
const ClientSuccessSection = lazy(() => import("./ClientSuccessSection"));

const WhyChooseus = () => {
  return (
    <>
      <Helmet>
  <title>
    Why Choose Winglo| Industry Experience & Cloud-First Architecture
  </title>

  <meta
    name="description"
    content="Discover why institutions choose Winglo. With 20+ years of industry experience, cloud-first architecture, and a customer-centric approach, we deliver secure, scalable, and high-performance digital solutions for Healthcare and Education."
  />

  <meta
    name="keywords"
    content="Why Choose Winglo, industry experience, cloud-first architecture, customer-centric IT company, healthcare software expertise, education ERP provider, enterprise technology solutions"
  />

  <meta property="og:title" content="Why Choose Winglo" />
  <meta
    property="og:description"
    content="Industry expertise, scalable cloud architecture, and customer-focused innovation — discover what makes Winglo different."
  />
  <meta property="og:type" content="website" />
</Helmet>


      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
      <CoreStrengthsSection />
      <CompetitiveAdvantageSection />
      <ClientSuccessSection />
      </Suspense>
    </>
  );
};

export default WhyChooseus;
